import { treeviaGateway } from '../clients/AxiosClients'

export const vinculaPrognose = async (body) => {
	return await treeviaGateway.post('/ms-prognoses/vinculaprognose/aplicar-prognose', body, {
		timeout: 600000,
	})
}
